<template>
    <v-card elevation="0" color="transparent" class="mb-4">
        <v-card-title class="justify-content-center align-content-center" v-if="mainLabel">{{ mainLabel }}
        </v-card-title>
        <v-card-subtitle v-if="mainLabel==='سایت های پیشنهادی'" class="mx-auto text-center mt-3">شما می توانید حداکثر 5
            سایت که مورد پسند شما بوده را برای ما ثبت کنید تا متخصصان ما سریعتر و
            بهتر نیازهای شما را تشخیص دهند
        </v-card-subtitle>
        <v-card-subtitle v-else-if="mainLabel==='منوهای موردنیاز'" class="mx-auto text-right mt-3">
           لطفا منوهایی که برای سایت خود درنظر دارید را در این قسمت وارد نمایید.
        </v-card-subtitle>
        <v-card-subtitle v-else-if="mainLabel==='سایت های رقبا'" class="mx-auto text-center mt-3">
            لطفا سایت هایی که رقیب شما هستند را برای متخصصان ما اضافه نمایید. تا با سرعت بیشتری بررسی انجام شود.
        </v-card-subtitle>
        <v-card v-for="(x, i) in value" :key="i" outlined class="mb-4">

            <v-card-title>
                <v-chip
                        outlined
                        color="#009688">
                    <span v-html="mainLabel==='منوهای موردنیاز'? 'منو':'سایت'">{{
                            mainLabel === 'سایت' ? 'منوهای موردنیاز' : 'منو'
                        }}</span> {{ i + 1 }}
                </v-chip>

                <v-spacer/>
                <v-btn x-small fab elevation="0" outline color="error" @click="deleteKeyValue(x, i)">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </v-card-title>

            <v-row align="center" class="ma-0 pt-3">
                <v-col cols="6" lg="6" class="pt-0">
                    <v-text-field :label="keyLabel!==null?keyLabel:'عنوان'" dense v-model="x.key" :rules="mainLabel==='منوهای موردنیاز'? '' : rules "
                                  outlined id="propKey"/>
                </v-col>
                <v-col cols="6" lg="6" class="pt-0">
                    <v-text-field :label="valueLabel!==null?valueLabel:'توضیحات'" dense v-model="x.value" outlined
                                  id="propValue"/>
                </v-col>

            </v-row>
        </v-card>

        <v-card-actions class="pa-0 my-4">
            <v-btn block @click="newKeyValue">
                <v-icon>mdi-plus</v-icon>
                {{ buttonName }}
            </v-btn>
        </v-card-actions>

        <v-divider/>
    </v-card>


</template>

<script>

export default {
    props: ['value', 'errors', 'dense', 'return_object', 'keyLabel', 'valueLabel', 'mainLabel'],

    data() {
        return {
            input: this.value,
            buttonName: 'افزودن سایت',
            rules: [
                (value) => this.isURL(value) || "لینک سایت باید بصورت https://terminalads.com یا www.terminalads.com وارد شود. ",
            ],
        }
    },
    name: "siteSelect",
    methods: {
        newKeyValue() {
            this.value.push({
                id: this.value.length + 1,
                key: '',
                value: '',

            })
        },
        deleteKeyValue(x, i) {
            this.value.splice(this.value.indexOf(x), 1);
        },
        isURL(str) {
            var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
            var without_regex = new RegExp("^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
            if (regex.test(str) || without_regex.test(str)) {
                return true
            } else {
                return false;
            }
        },

    },
    watch: {
        input() {
            this.$emit('input', this.input)
        }
    },
    mounted() {
        this.buttonName = this.mainLabel
    }
}
</script>

<style scoped>

</style>